import React from 'react';
import { Drawer as MuiDrawer } from '@material-ui/core';

const Drawer = props => <MuiDrawer {...props} />;

export default Drawer;
